import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import { useUiManager } from './useUiManager';

export function useCurrentConversationId() {
  const uiManager = useUiManager();
  const [[currentConversationId]] = useReadableEventRefresher(uiManager.currentConversation);

  if (!currentConversationId) {
    uiManager.createNewChat();
  }

  return currentConversationId!;
}